module.exports = __webpack_public_path__ + "img/gemischtertellerohnehintergrund.5c873ff5.png";